import GD from '../GD'

class Logger {
  private readonly logs: boolean = false
  private readonly errors: boolean = false

  constructor(){
    if(window.DCC_SHARED.enableLog || window.DCC_CONFIG.LOGGER){
      this.logs=true
      this.errors=true
    }

    GD.LOG.subscribe((vals: string | object)=>{
      if(!this.logs)
        return
      if(Array.isArray(vals))
        console.log.apply(this,vals)
      console.log(vals)
    })
    GD.LOGE.subscribe((vals:string)=>{
      if(!this.errors)
        return
      if(Array.isArray(vals))
        console.error.apply(this,vals)
      else console.error(vals)
    })
    GD.SERVICE_READY.invoke('logger')
  }
}

export default Logger